import { SET_RUNTIME_CONFIG } from './constants';

export function setRuntimeConfig(config) {
  return { type: SET_RUNTIME_CONFIG, config };
}
